import { TrifectaLaunchParamsDto } from '../../../models/trifecta-dto';

export function initLaunchParams(launchParams: TrifectaLaunchParamsDto, maxLines: number): void {
  const machineState = {
    ...launchParams.replayData!.spins[0],
    freeSpinsInfo: null,
    bonusInfo: null,
    viewReels: [],
  };
  launchParams.initData = {
    bets: [],
    defaultBet: 0,
    configs: [],
    commands: [],
    maxLines: maxLines,
    betMultiplier: 1,
    symbols: [],
    machineState,
    isCheatUser: false,
  };

  launchParams.betValues = [launchParams.replayData!.bet];
  launchParams.languageId = launchParams.languageId || 'en';
  const balance = launchParams.replayData!.balance + launchParams.replayData!.bet;

  launchParams.game = launchParams.gameId!;
  launchParams.balance = balance;
  launchParams.showAutoPlay = false;
  launchParams.showBuyFeatures = false;
  launchParams.showNetPosition = true;
}
